/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

module.exports = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.newpassword': 'New Password',
  'user.currentpassword': 'Current Password',
  'user.newpasswordagain': 'New Password Again',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',


  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'Tickets',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.topic': 'Topic',
  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytics',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservations and Bookings',
  'pages.title.tickets': 'Leads and Tickets',
  'pages.title.propinfo': 'Responses',
  'pages.title.discounts': 'Discounts and Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'メッセージ',
  'chat.contacts': '連絡先',
  'chat.saysomething': '何か言って..',

  /* 06.02.Survey */
  'survey.delete': '消去',
  'survey.edit': '編集',
  'survey.add-new': '新しく追加する',
  'survey.add-new-title': '新しいアンケートを追加',
  'survey.title': 'タイトル',
  'survey.category': 'カテゴリー',
  'survey.label': 'ラベル',
  'survey.status': '状態',
  'survey.cancel': 'キャンセル',
  'survey.submit': '提出する',
  'survey.another-action': '別のアクション',
  'survey.display-options': '表示オプション',
  'survey.orderby': '注文方法:',
  'survey.all-surveys': 'すべてのアンケート',
  'survey.completed-surveys': '完了したアンケート',
  'survey.categories': 'カテゴリー',
  'survey.active-surveys': 'アクティブなアンケート',
  'survey.labels': 'ラベル',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',

  /* Property Info */
  'property-info.about-property': '物件について',
  'property-info.about-properties': 'プロパティについて',
  'property-info.facilities-services': '施設とサービス',
  'property-info.property-facilities': '物件設備',
  'property-info.room-amenities': '部屋のアメニティ',
  'property-info.property-contact': '物件連絡先',
  'property-info.property-activities': '財産活動',
  'property-info.property-location': '物件の所在地',
  'property-info.about-rooms': '部屋',
  'property-info.about-sites': 'サイトについて',
  'property-info.special-emergencies': '緊急事態',
  'property-info.gallery': 'ギャラリー',
  'property-info.policies': 'ポリシー',
  'property-info.nearby': '近く',
  'property-info.transport': '輸送',
  'property-info.location': '位置',
  'property-info.about-rhproperty': '老人ホームについて',
  'property-info.related-topics': '関連トピック',
  'property-info.assistant-options': 'アシスタントメニュー',
  'property-info.restaurant-assistant-information': 'レストラン情報',
  'property-info.restaurant-assistant-options': 'ウェルカムメッセージ',
  'property-info.channel-messages': 'チャンネルメッセージ',
  'property-info.icon.gallery': 'アイコンギャラリー',
  'property-info.copilot': '副操縦士',
  'property-info.sprint': 'スプリント',
  'property-info.home-information': 'ホーム情報',
  'property-info.loction': '所在地',
  'property-info.rooms-and-images': '部屋とイメージ',
  'property-info.trainig-data': 'トレーニングデータ',
  'property-info.flows': '流れ',
  'property-info.add-your-own': '独自のものを追加',
  'property-info-utility-miscellaneous': 'その他',
  'property-info-utility-payment': '支払い',
  'property-info-utility-broadband': 'ブロードバンド',
  'property-info-utility-emergency': '緊急',
  'property-info-utility-mobile': '携帯',
  'property-info-utility-moving': '移動',

  /** Rate & Promo */
  'rate-promo.rate-plans': '料金プラン',
  'rate-promo.rate-plan-addons': "アドオン",
  'rate-promo.rate-plan-promos': 'プロモーション',

  'title.property-information': '物件情報',

  'property.message': 'メッセージ',
  'property.example': '例',
  'property.link': 'リンク',
  'property.image-carousel': '画像カルーセル',
  'property.Title': 'タイトル',
  'property.SubTitle': 'サブタイトル',

  'property.add-invoke-api': 'APIの呼び出し',
  'property.add-message-button': 'メッセージの追加',
  'property.add-img-button': '画像の追加',
  'property.add-link-button': 'リンクを追加',
  'property.add-herocard-button': 'ヒーローカードを追加',
  'property.add-api-button': 'ボタンの追加',

  'menu.about-property': '物件について',
  'menu.property-facilities': '物件設備',
  'menu.room-amenities': '部屋のアメニティ',
  'menu.property-contact': '物件連絡先',
  'menu.about-rooms': '部屋',
  'menu.special-emergencies': '緊急事態',
  'menu.show-filter': 'フィルター',
  'menu.new': '新しい',

  'dashboards.common-asked': 'よくある質問',
  'dashboards.website-visitor-asking': 'ウェブサイト訪問者が質問していること',
  'dashboards.visit-country': '国別のウェブサイト訪問数',
  'dashboards.visit-traffic': 'Web サイトのトラフィックの国',
  'dashboards.rooms-product': '客室と製品',
  'dashboards.popular-room-product': '人気のお部屋と商品',

  'dashboards.messenger-stats': '人気メニュー',
  'dashboards.messenger-stats-topic-view': 'メニュー項目ビューの統計',
  'dashboards.messenger-stats-visits': 'メニュー項目のビュー',
  'dashboards.opening-menu-items': 'メニュー項目を開いた Web サイト訪問者の数',

  'dashboards.number-totalavatarclick': 'アバターの合計クリック数',

  'dashboards.clicks': 'クリック数',
  'dashboards.leads': 'リード',
  'dashboards.hours': '時間',
  'dashboards.minutes': '分',

  'dashboards.ai-chatbot': 'AIチャットボット',
  'dashboards.compendium': '概要',
  'dashboards.compendium-digital-usage': 'デジタル大要の使用法',
  'dashboards.compendium-unique-visits': 'ユニークな訪問数',
  'dashboards.compendium-opening-menu-items': '閲覧されたメニュー項目の数',
  'dashboards.compendium-total-digital-clicks': 'デジタル大要録の合計クリック数',

  'property.delete': '消去',
  'menu.userroles': 'ユーザーと役割',
  'menu.ratebookings': '料金と予約',
  'dashboards.engagement-time': 'デジタル アシスタントのエンゲージメント時間',
  'dashboards.conversations-minutes': '合計分と夜間（午後 7 時から午前 7 時まで）の会話時間（分）',
  'dashboards.visitor-questions': '訪問者の質問',
  'dashboards.recent-queries': '最近のクエリ',
  'dashboards.visitor-saying': '訪問者がデジタル アシスタントに言ったこと',
  'dashboards.contacts-prechatform-leavemessage': 'プレチャットフォームから保存された連絡先とメッセージを残す',
  'menu.dashboards': '洞察',
  'menu.ari': '空室状況と料金',
  'menu.conversations': '会話',
  'menu.conversations.unified-inbox': '統合された受信トレイ',
  'menu.conversations.active': 'アクティブなチャット',
  'menu.conversations.archives': 'アーカイブ',
  'menu.conversations.missed-responses': '応答の欠落',
  'menu.conversations.ticket': 'チケット',
  'menu.conversations.reply-templates': '返信テンプレート',
  'menu.bookings': '予約と予約',
  'menu.tickets': 'リードとチケット',
  'menu.propinfo': 'ナレッジハブ',
  'menu.rate-promos': '料金とプロモーション',
  'menu.finance': 'ファイナンス',
  'menu.integration': '接続する',
  'menu.admin': '管理者とセキュリティ',
  'menu.favourites': 'お気に入り',
  'menu.recommender': '会話の流れ',
  'menu.assistant-setup': 'アシスタントのセットアップ',
  'menu.admin-insights': '管理者の洞察',
  'menu.super-admin': 'スーパー管理者',
  'menu.groups': 'グループ',
  'menu.properties': 'プロパティ',
  'menu.service-provider': 'サービスプロバイダー',
  'menu.spaces': 'スペース',

  'dashboards.space-booking': 'スペースの予約',
  'dashboards.gift-voucher': 'ギフト券',
  'dashboards.chatbots': 'チャットボット',
  'dashboards.form': 'から',
  'dashboards.to': 'に',
  'dashboards.active-groups': 'アクティブなグループ',
  'dashboards.active-properties': 'アクティブなプロパティ',
  'dashboards.live-properties': 'ライブプロパティ',
  'dashboards.properties-going': '日付範囲ごとに公開されるプロパティ',
  'dashboards.start-date': '開始日',
  'dashboards.end-date': '終了日',

  'dashboards.website-visits': 'ウェブサイトの訪問数',
  'dashboards.unique-visitors': 'ユニークな訪問者',
  'dashboards.last-week': '先週',
  'dashboards.this-week': '今週',
  'dashboards.this-month': '今月',
  'dashboards.previous-month': '前月',
  'dashboards.yeartodate': '年初来',
  'dashboards.lastyear': '去年',
  'dashboards.last-7-days': '過去 7 日間',
  'dashboards.last-30-days': '過去 30 日間',
  'dashboards.last-60-days': '過去60日間',
  'dashboards.last-90-days': '過去90日間',
  'dashboards.conversion-rates': 'コンバージョン率',
  'dashboards.digital-assistant-engagement': 'デジタル アシスタントの関与',
  'dashboards.total-overnight-conversations': '合計および一晩（午後 7 時から午前 7 時まで）の会話',
  'dashboards.percentage-accuracy': '精度を理解する',
  'dashboards.percentage-conversion': 'Web サイトのトラフィックからチャットへの変換',
  'dashboards.percentage-avatarclick': 'アバタークリックへのウェブサイトトラフィック',
  'dashboards.percentage-negativefeedback': 'アバターのクリック数に占める否定的なフィードバックの割合',
  'dashboards.percentage-amenties': 'アメニティに関する問い合わせ',
  'dashboards.percentage-booking': '予約に関するお問い合わせ',
  'dashboards.percentage-webchats': 'ウェブサイトチャット',
  'dashboards.percentage-facebookchat': 'Facebook チャット',
  // 'dashboards.number-webchattime': 'Total Web Chat Time',
  'dashboards.number-webchattime': '合計会話時間',
  'dashboards.number-totalconversation': '総会話数',
  'dashboards.number-websiteconversation': 'ウェブサイトでの会話',
  'dashboards.number-facebookconversation': 'Facebookでの会話',
  'dashboards.number-estimatedtimesaving': '推定時間の節約',
  'dashboards.number-googlemapsconversation': 'Google マップでの会話',
  'dashboards.number-whatsappconversation': 'WhatsApp での会話',
  'dashboards.number-instagramconversation': 'インスタグラムでの会話',
  'dashboards.number-agentconversation': 'エージェントの会話',
  'dashboards.number-amenityqueries': 'アメニティに関する問い合わせ',
  'dashboards.number-bookingenquiries': '予約に関する問い合わせ',
  'dashboards.number-groupbookingenquiries': '団体予約に関するお問い合わせ',
  'dashboards.number-eventenquiries': 'イベントに関するお問い合わせ',
  'dashboards.number-longstayenquiries': '長期滞在のお問い合わせ',
  'dashboards.number-totaltickets': 'チケット',
  'dashboards.number-returncustomer': '返品のお客様',
  'dashboards.number-redirects': 'ウェブサイトのリダイレクト',
  'dashboards.number-bookingengineleads': '予約エンジンのリード',
  'dashboards.number-roomnightsreferred': "紹介された部屋泊数",
  'dashboards.number-revenuereferred': "参照される収益",
  'menu.bookingsmenu': '予約',
  'menu.guests': 'ゲスト情報',
  'menu.whatsnew': "新着情報",

  'menu.formbuilder': 'フォームビルダー',
  'forms.forms-title': 'フォーム',

  'menu.virtualfrontdesk': 'バーチャルフロントデスク',
  'menu.guestservice': 'お客様サービス',
  'virtual-front.common-questions': "よくある質問",
  'virtual-front.add-on-upsells': "アドオンとアップセル",
  'virtual-front.service-order': "サービス注文",
  // 'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
  'virtual-front.guest-service-add-on-upsells': "デジタル大要",
  'virtual-front.outbound': "アウトバウンド",
  'virtual-messenger': "メッセンジャーX",

  'missed-response.missed-response-title': "返信のタイトルがありませんでした",
};
